// ==============================|| OVERRIDES - STEPS ||============================== //

export default function Tabs() {
	return {
		MuiStepIcon: {
			styleOverrides: {
				root: {
					"&.Mui-active": {
						color: "#43BD98",
					},
					"&.Mui-completed": {
						color: "#43BD98",
					},
				},
			},
		},
	};
}
